module.exports = __webpack_public_path__ + "img/hr-H-T-3-unload-standup-shadow.5bad6c57.png";